import React, { useEffect } from 'react';
import { GrContact } from "react-icons/gr";
import { Link } from 'react-router-dom';

const CTABtn = () => {
    
    useEffect(() => {
        const url = 'https://wati-integration-prod-service.clare.ai/v2/watiWidget.js?19492';
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = url;

        script.onload = () => {
            if (window.CreateWhatsappChatWidget) {
                window.CreateWhatsappChatWidget({
                    enabled: true,
                    chatButtonSetting: {
                        backgroundColor: "#00e785",
                        ctaText: "Chat with us",
                        borderRadius: "25",
                        marginLeft: "0",
                        marginRight: "20",
                        marginBottom: "90",
                        ctaIconWATI: false,
                        position: "right"
                    },
                    brandSetting: {
                        brandName: "Wati",
                        brandSubTitle: "undefined",
                        brandImg: "https://admissions.sriramanujar.ac.in/assets/logo.png",
                        welcomeText: "Welcome to SREC Admissions 2025!!",
                        messageText: "Hello, %0A I have a question about {{page_link}}",
                        backgroundColor: "#00e785",
                        ctaText: "Chat with us",
                        borderRadius: "25",
                        autoShow: false,
                        phoneNumber: "919629712485"
                    }
                });
            }
        };

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div>
            {/* <Link to='/#' className='apply-now-btn flex flex-row justify-center gap-2 items-center'>
                <GrContact />
                <div>Apply Now</div>
            </Link> */}
        </div>
    );
};

export default CTABtn;
